import React from 'react';
import {useContext} from 'react'
import { Modal, Box, Typography, Button } from '@mui/material';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json';
import docco from 'react-syntax-highlighter/dist/esm/styles/hljs/docco';
import atomOneDark from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-dark';
import { ThemeContext } from '../../context/ThemeContext';

SyntaxHighlighter.registerLanguage('json', json);
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  bgcolor: 'var(--bg-body)',
  boxShadow: 24,
  p: 2,
  overflowY: 'auto',
  borderRadius: '8px',
  border:'1px solid #f3f4f6',
  outline:'none'
};

export default function ViewColModal({title, isOpen, onClose, content }) {
  const { theme } = useContext(ThemeContext);  
  let isJson = false;
  let formattedContent = content;

  if (typeof content === 'string' && content.trim().startsWith('{')) {
    try {
      const parsed = JSON.parse(content);
      formattedContent = JSON.stringify(parsed, null, 2);
      isJson = true;
    } catch (e) {
      isJson = false;
    }
  }

  return (
    <Modal open={isOpen} onClose={onClose} disableScrollLock={true}>
      <Box sx={style}>
        <Typography variant="h6" gutterBottom>{title}</Typography>
        <Box sx={{ maxHeight: '60vh', overflow: 'auto', mb: 2 }}>
          {isJson ? (
            <SyntaxHighlighter language="json"  style={ theme == 'dark' ? atomOneDark : docco}>
              {formattedContent}
            </SyntaxHighlighter>
          ) : (
            <Typography>{formattedContent}</Typography>
          )}
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <Button variant="contained" sx={{background:"#4b5563", color:"#ffffff"}} onClick={onClose}>Close</Button>
        </Box>
      </Box>
    </Modal>
  );
}
